import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const BaseLeadPage = _ref => {
  let {
    form: FormComponent,
    content: ContentComponent,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(ContentComponent, {
    form: /*#__PURE__*/_jsx(FormComponent, {
      ...props
    }),
    ...props
  });
};
export default BaseLeadPage;